import React from "react";
import { WorkshopFormat } from "../data";

interface Props {
  workshop: WorkshopFormat;
}

const icons = {
  compass: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" />
      <polygon points="12 6 15 12 12 18 9 12" fill="currentColor" />
    </svg>
  ),
  spark: (
    <svg viewBox="0 0 24 24">
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  ),
  bot: (
    <svg viewBox="0 0 24 24">
      <rect x="4" y="6" width="16" height="12" rx="2" />
      <circle cx="9" cy="12" r="1.5" fill="currentColor" />
      <circle cx="15" cy="12" r="1.5" fill="currentColor" />
      <path d="M12 3v3M8 21l4-3 4 3" />
    </svg>
  ),
  puzzle: (
    <svg viewBox="0 0 24 24">
      <path d="M9 4h6v3a2 2 0 1 0 0 4v3a2 2 0 1 0 0 4v3H9v-3a2 2 0 1 0 0-4V8a2 2 0 1 0 0-4z" />
    </svg>
  ),
};

const WorkshopCard = ({ workshop }: Props) => (
  <article
    className="workshop-card"
    id={workshop.id}
    aria-labelledby={`${workshop.id}-title`}
  >
    <div className="workshop-icon" aria-hidden="true">
      {icons[workshop.icon]}
    </div>
    <span className="tag">{workshop.label}</span>
    <h3 id={`${workshop.id}-title`}>{workshop.title}</h3>
    <p className="who">{workshop.subtitle}</p>
    <p className="summary">{workshop.summary}</p>
    <ul>
      {workshop.outcomes.map((outcome) => (
        <li key={outcome}>{outcome}</li>
      ))}
    </ul>
    <div className="card-actions">
      <a href="#enquire" className="btn btn-blue btn--compact">
        {workshop.id === "custom" ? "Talk to us" : "Enquire"}
      </a>
      {workshop.pdfUrl && (
        <a
          href={workshop.pdfUrl}
          className="btn btn-outline-blue btn--compact pdf-download"
          target="_blank"
          rel="noopener"
          data-workshop={workshop.title}
          data-workshop-id={workshop.id}
          aria-label={`Download ${workshop.title} workshop PDF (opens in new tab)`}
        >
          Download PDF
        </a>
      )}
    </div>
  </article>
);

export default WorkshopCard;
